export default {
  "es": {
    "Caja del Día": "Caja del Día",
    "Control de ingresos y gastos diarios": "Control de ingresos y gastos diarios",
    "Ventas POS": "Ventas POS",
    "Otros Ingresos": "Otros Ingresos",
    "Gastos": "Gastos",
    "Caja Neta": "Caja Neta",
    "Resumen del Mes": "Resumen del Mes",
    "Balance": "Balance",
    "Agregar Ingreso": "Agregar Ingreso",
    "Agregar Gasto": "Agregar Gasto",
    "Hoy": "Hoy",
    "Enviar por": "Enviar por",
    "Movimientos del Día": "Movimientos del Día",
    "Agrega ingresos o gastos para comenzar": "Agrega ingresos o gastos para comenzar",
    "Ventas del Punto de Venta": "Ventas del Punto de Venta",
    "Total de ventas POS del día": "Total de ventas POS del día",
    "Descripción (opcional)": "Descripción (opcional)",
    "Ej: Pago de cliente": "Ej: Pago de cliente",
    "Día anterior": "Día anterior",
    "Día siguiente": "Día siguiente",
    "Seleccionar fecha": "Seleccionar fecha",
    "Actualizar": "Actualizar",
    "Consultar a BRIEFY": "Consultar a BRIEFY",
    "Los nuevos movimientos se registran hoy. Vuelve a Hoy para agregar uno.": "Los nuevos movimientos se registran hoy. Vuelve a Hoy para agregar uno.",
    "No se pudo cargar la caja. Intenta actualizar.": "No se pudo cargar la caja. Intenta actualizar.",
    "Eliminar movimiento": "Eliminar movimiento",
    "Cerrar": "Cerrar",
    "Guardando…": "Guardando…",
    "Guardar movimiento": "Guardar movimiento",
    "Sin categoría": "Sin categoría",
    "Monto": "Monto",
    "Categoría": "Categoría",
    "Ingresos": "Ingresos",
    "Reporte de Caja": "Reporte de Caja",
    "Mi Negocio": "Mi Negocio",
    "Generado por BRIEFCASE": "Generado por BRIEFCASE",
    "Por favor ingresa un monto válido": "Por favor ingresa un monto válido",
    "Por favor selecciona una categoría": "Por favor selecciona una categoría",
    "¿Eliminar esta transacción?": "¿Eliminar esta transacción?",
    "Error al guardar. Por favor intenta de nuevo.": "Error al guardar. Por favor intenta de nuevo.",
    "🛒 Ventas": "🛒 Ventas",
    "🔧 Servicios": "🔧 Servicios",
    "💼 Comisiones": "💼 Comisiones",
    "🏠 Alquiler Cobrado": "🏠 Alquiler Cobrado",
    "📈 Intereses": "📈 Intereses",
    "↩️ Reembolsos": "↩️ Reembolsos",
    "📦 Compras/Inventario": "📦 Compras/Inventario",
    "🏢 Alquiler Local": "🏢 Alquiler Local",
    "💡 Servicios (Luz/Agua/Gas)": "💡 Servicios (Luz/Agua/Gas)",
    "📱 Internet/Teléfono": "📱 Internet/Teléfono",
    "👥 Nómina/Salarios": "👥 Nómina/Salarios",
    "🏛️ Impuestos": "🏛️ Impuestos",
    "🛡️ Seguros": "🛡️ Seguros",
    "🚗 Transporte/Gasolina": "🚗 Transporte/Gasolina",
    "📣 Marketing/Publicidad": "📣 Marketing/Publicidad",
    "🔧 Mantenimiento/Reparaciones": "🔧 Mantenimiento/Reparaciones",
    "🗃️ Suministros de Oficina": "🗃️ Suministros de Oficina",
    "💻 Software/Suscripciones": "💻 Software/Suscripciones",
    "🏦 Comisiones Bancarias": "🏦 Comisiones Bancarias",
    "💳 Pago de Préstamos": "💳 Pago de Préstamos",
    "📋 Otros Gastos": "📋 Otros Gastos",
    "💰 Otros Ingresos": "💰 Otros Ingresos"
  },
  "en": {
    "Caja del Día": "Daily cash",
    "Control de ingresos y gastos diarios": "Track daily income and expenses",
    "Ventas POS": "POS sales",
    "Otros Ingresos": "Other Income",
    "Gastos": "Expenses",
    "Caja Neta": "Net cash",
    "Resumen del Mes": "Monthly summary",
    "Balance": "Balance",
    "Agregar Ingreso": "Add income",
    "Agregar Gasto": "Add expense",
    "Hoy": "Today",
    "Enviar por": "Send via",
    "Movimientos del Día": "Daily transactions",
    "Agrega ingresos o gastos para comenzar": "Add income or expenses to get started",
    "Ventas del Punto de Venta": "Point-of-sale sales",
    "Total de ventas POS del día": "Daily POS sales total",
    "Descripción (opcional)": "Description (optional)",
    "Ej: Pago de cliente": "e.g. Customer payment",
    "Día anterior": "Previous day",
    "Día siguiente": "Next day",
    "Seleccionar fecha": "Select date",
    "Actualizar": "Refresh",
    "Consultar a BRIEFY": "Ask BRIEFY",
    "Los nuevos movimientos se registran hoy. Vuelve a Hoy para agregar uno.": "New transactions are recorded today. Return to Today to add one.",
    "No se pudo cargar la caja. Intenta actualizar.": "Cash data could not be loaded. Try refreshing.",
    "Eliminar movimiento": "Delete transaction",
    "Cerrar": "Close",
    "Guardando…": "Saving…",
    "Guardar movimiento": "Save transaction",
    "Sin categoría": "Uncategorized",
    "Monto": "Amount",
    "Categoría": "Category",
    "Ingresos": "Income",
    "Reporte de Caja": "Cash report",
    "Mi Negocio": "My business",
    "Generado por BRIEFCASE": "Generated by BRIEFCASE",
    "Por favor ingresa un monto válido": "Please enter a valid amount",
    "Por favor selecciona una categoría": "Please select a category",
    "¿Eliminar esta transacción?": "Delete this transaction?",
    "Error al guardar. Por favor intenta de nuevo.": "Could not save. Please try again.",
    "🛒 Ventas": "🛒 Sales",
    "🔧 Servicios": "🔧 Services",
    "💼 Comisiones": "💼 Commissions",
    "🏠 Alquiler Cobrado": "🏠 Rental income",
    "📈 Intereses": "📈 Interest",
    "↩️ Reembolsos": "↩️ Refunds",
    "📦 Compras/Inventario": "📦 Purchases/Inventory",
    "🏢 Alquiler Local": "🏢 Business rent",
    "💡 Servicios (Luz/Agua/Gas)": "💡 Utilities (Power/Water/Gas)",
    "📱 Internet/Teléfono": "📱 Internet/Phone",
    "👥 Nómina/Salarios": "👥 Payroll/Wages",
    "🏛️ Impuestos": "🏛️ Taxes",
    "🛡️ Seguros": "🛡️ Insurance",
    "🚗 Transporte/Gasolina": "🚗 Transport/Fuel",
    "📣 Marketing/Publicidad": "📣 Marketing/Advertising",
    "🔧 Mantenimiento/Reparaciones": "🔧 Maintenance/Repairs",
    "🗃️ Suministros de Oficina": "🗃️ Office supplies",
    "💻 Software/Suscripciones": "💻 Software/Subscriptions",
    "🏦 Comisiones Bancarias": "🏦 Bank Fees",
    "💳 Pago de Préstamos": "💳 Loan repayments",
    "📋 Otros Gastos": "📋 Other Expenses",
    "💰 Otros Ingresos": "💰 Other Income"
  },
  "pt": {
    "Caja del Día": "Caixa do dia",
    "Control de ingresos y gastos diarios": "Controle de receitas e despesas diárias",
    "Ventas POS": "Vendas PDV",
    "Otros Ingresos": "Outras receitas",
    "Gastos": "Despesas",
    "Caja Neta": "Caixa líquido",
    "Resumen del Mes": "Resumo do mês",
    "Balance": "Saldo",
    "Agregar Ingreso": "Adicionar receita",
    "Agregar Gasto": "Adicionar despesa",
    "Hoy": "Hoje",
    "Enviar por": "Enviar por",
    "Movimientos del Día": "Movimentações do dia",
    "Agrega ingresos o gastos para comenzar": "Adicione receitas ou despesas para começar",
    "Ventas del Punto de Venta": "Vendas do ponto de venda",
    "Total de ventas POS del día": "Total de vendas PDV do dia",
    "Descripción (opcional)": "Descrição (opcional)",
    "Ej: Pago de cliente": "Ex.: Pagamento de cliente",
    "Día anterior": "Dia anterior",
    "Día siguiente": "Próximo dia",
    "Seleccionar fecha": "Selecionar data",
    "Actualizar": "Atualizar",
    "Consultar a BRIEFY": "Consultar o BRIEFY",
    "Los nuevos movimientos se registran hoy. Vuelve a Hoy para agregar uno.": "Novas movimentações são registradas hoje. Volte para Hoje para adicionar uma.",
    "No se pudo cargar la caja. Intenta actualizar.": "Não foi possível carregar o caixa. Tente atualizar.",
    "Eliminar movimiento": "Excluir movimentação",
    "Cerrar": "Fechar",
    "Guardando…": "Salvando…",
    "Guardar movimiento": "Salvar movimentação",
    "Sin categoría": "Sem categoria",
    "Monto": "Valor",
    "Categoría": "Categoria",
    "Ingresos": "Receitas",
    "Reporte de Caja": "Relatório de caixa",
    "Mi Negocio": "Meu negócio",
    "Generado por BRIEFCASE": "Gerado pelo BRIEFCASE",
    "Por favor ingresa un monto válido": "Insira um valor válido",
    "Por favor selecciona una categoría": "Selecione uma categoria",
    "¿Eliminar esta transacción?": "Excluir esta transação ?",
    "Error al guardar. Por favor intenta de nuevo.": "Não foi possível salvar. Tente novamente.",
    "🛒 Ventas": "🛒 Vendas",
    "🔧 Servicios": "🔧 Serviços",
    "💼 Comisiones": "💼 Comissões",
    "🏠 Alquiler Cobrado": "🏠 Aluguel recebido",
    "📈 Intereses": "📈 Juros",
    "↩️ Reembolsos": "↩️ Reembolsos",
    "📦 Compras/Inventario": "📦 Compras/Estoque",
    "🏢 Alquiler Local": "🏢 Aluguel comercial",
    "💡 Servicios (Luz/Agua/Gas)": "💡 Serviços (Luz/Água/Gás)",
    "📱 Internet/Teléfono": "📱 Internet/Telefone",
    "👥 Nómina/Salarios": "👥 Folha/Salários",
    "🏛️ Impuestos": "🏛️ Impostos",
    "🛡️ Seguros": "🛡️ Seguros",
    "🚗 Transporte/Gasolina": "🚗 Transporte/Combustível",
    "📣 Marketing/Publicidad": "📣 Marketing/Publicidade",
    "🔧 Mantenimiento/Reparaciones": "🔧 Manutenção/Reparos",
    "🗃️ Suministros de Oficina": "🗃️ Materiais de escritório",
    "💻 Software/Suscripciones": "💻 Software/Assinaturas",
    "🏦 Comisiones Bancarias": "🏦 Tarifas bancárias",
    "💳 Pago de Préstamos": "💳 Pagamento de empréstimos",
    "📋 Otros Gastos": "📋 Outras despesas",
    "💰 Otros Ingresos": "💰 Outras receitas"
  },
  "fr": {
    "Caja del Día": "Caisse du jour",
    "Control de ingresos y gastos diarios": "Suivi des recettes et dépenses quotidiennes",
    "Ventas POS": "Ventes en caisse",
    "Otros Ingresos": "Autres revenus",
    "Gastos": "Dépenses",
    "Caja Neta": "Solde net",
    "Resumen del Mes": "Résumé du mois",
    "Balance": "Solde",
    "Agregar Ingreso": "Ajouter une recette",
    "Agregar Gasto": "Ajouter une dépense",
    "Hoy": "Aujourd’hui",
    "Enviar por": "Envoyer via",
    "Movimientos del Día": "Mouvements du jour",
    "Agrega ingresos o gastos para comenzar": "Ajoutez une recette ou une dépense pour commencer",
    "Ventas del Punto de Venta": "Ventes du point de vente",
    "Total de ventas POS del día": "Total des ventes du jour",
    "Descripción (opcional)": "Description (facultative)",
    "Ej: Pago de cliente": "Ex. : Paiement client",
    "Día anterior": "Jour précédent",
    "Día siguiente": "Jour suivant",
    "Seleccionar fecha": "Choisir une date",
    "Actualizar": "Actualiser",
    "Consultar a BRIEFY": "Consulter BRIEFY",
    "Los nuevos movimientos se registran hoy. Vuelve a Hoy para agregar uno.": "Les nouveaux mouvements sont enregistrés aujourd’hui. Revenez à Aujourd’hui pour en ajouter un.",
    "No se pudo cargar la caja. Intenta actualizar.": "Impossible de charger la caisse. Essayez d’actualiser.",
    "Eliminar movimiento": "Supprimer le mouvement",
    "Cerrar": "Fermer",
    "Guardando…": "Enregistrement…",
    "Guardar movimiento": "Enregistrer le mouvement",
    "Sin categoría": "Sans catégorie",
    "Monto": "Montant",
    "Categoría": "Catégorie",
    "Ingresos": "Recettes",
    "Reporte de Caja": "Rapport de caisse",
    "Mi Negocio": "Mon entreprise",
    "Generado por BRIEFCASE": "Généré par BRIEFCASE",
    "Por favor ingresa un monto válido": "Saisissez un montant valide",
    "Por favor selecciona una categoría": "Sélectionnez une catégorie",
    "¿Eliminar esta transacción?": "Supprimer cette transaction ?",
    "Error al guardar. Por favor intenta de nuevo.": "Enregistrement impossible. Réessayez.",
    "🛒 Ventas": "🛒 Ventes",
    "🔧 Servicios": "🔧 Services",
    "💼 Comisiones": "💼 Commissions",
    "🏠 Alquiler Cobrado": "🏠 Loyers perçus",
    "📈 Intereses": "📈 Intérêts",
    "↩️ Reembolsos": "↩️ Remboursements",
    "📦 Compras/Inventario": "📦 Achats/Stocks",
    "🏢 Alquiler Local": "🏢 Loyer commercial",
    "💡 Servicios (Luz/Agua/Gas)": "💡 Services (Électricité/Eau/Gaz)",
    "📱 Internet/Teléfono": "📱 Internet/Téléphone",
    "👥 Nómina/Salarios": "👥 Paie/Salaires",
    "🏛️ Impuestos": "🏛️ Impôts",
    "🛡️ Seguros": "🛡️ Assurances",
    "🚗 Transporte/Gasolina": "🚗 Transport/Carburant",
    "📣 Marketing/Publicidad": "📣 Marketing/Publicité",
    "🔧 Mantenimiento/Reparaciones": "🔧 Entretien/Réparations",
    "🗃️ Suministros de Oficina": "🗃️ Fournitures de bureau",
    "💻 Software/Suscripciones": "💻 Logiciels/Abonnements",
    "🏦 Comisiones Bancarias": "🏦 Frais bancaires",
    "💳 Pago de Préstamos": "💳 Remboursements de prêts",
    "📋 Otros Gastos": "📋 Autres dépenses",
    "💰 Otros Ingresos": "💰 Autres revenus"
  }
};